export enum DEVICE_TYPE_EXPONENTIAL_RANGE_ENUM {
  LACTATE_PRO_1_A_MIN = 51,
  LACTATE_PRO_1_A_MAX = 54,
  LACTATE_PRO_1_B_MIN = 0.85,
  LACTATE_PRO_1_B_MAX = 1.15,
  LACTATE_PRO_1_C_MIN = 0.01,
  LACTATE_PRO_1_C_MAX = 0.05,
  LACTATE_PRO_1_D_MIN = -0.3,
  LACTATE_PRO_1_D_MAX = 0.3,
}
